import { FC } from 'react'
import { useTranslation } from 'react-i18next'

import { Box, Grid } from '@mui/material'

import { useGET_studentAssignmentsQuery } from 'redux/api/assignmentsApi'

import BoxTitle from 'components/atoms/BoxTitle'

import { useTableModel } from 'utils/tableModels/useStudentAssignmentsDashboardTableModel'

import Table from './../dashboard/Table'

const Assignments: FC = () => {
  const { t } = useTranslation()

  const { data } = useGET_studentAssignmentsQuery({
    page: 1,
  })
 
  return (
    <Box className='thick-border purple-table-row' sx={{ height: '100%' }}>
      <Grid container spacing={2}>
        <Grid item xs={12} xl={6}>
          <BoxTitle title={t('common.assignments')} text='' />
        </Grid>
        <Grid item xs={12}>
          <Table useTableModel={useTableModel} data={data?.results}  />
        </Grid>
      </Grid>
    </Box>
  )
}

export default Assignments
